const Logout = () => {
    return (
        <>
            <section className="py-5" >
                <div className="container">
                    <div className="row pt-5 justify-content-center">
                        <div className="col-12 mb-5 text-center">
                            <div className="thankyou-img mb-4">
                                <img
                                    src="images/thank-you.png"
                                    className="img-fluid"
                                    style={{ maxWidth: 200, transition: "transform 0.3s ease-in-out" }}
                                    alt=""
                                    onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                                    onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                                />
                            </div>
                            <div className="thankyou-text mt-4">
                                <h3 className="main-heading" style={{ fontSize: "2rem", color: "black", fontWeight: "700", letterSpacing: "1px", textTransform: "uppercase" }}>
                                    {"Thank You!"}
                                </h3>
                                <p style={{ fontSize: "1.2rem", maxWidth: "600px", margin: "0 auto", lineHeight: "1.6" }}>
                                    {"Visit galaxie portal to login again"}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
export default Logout;